export default __webpack_public_path__ + "static/media/icon-training.efb3fe1e.svg";